module.exports = __webpack_public_path__ + "static/media/LogoHelacor.7de41769.svg";